import React from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import AppContext from "../../AppContext";

import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import SvgIcon from "@mui/material/SvgIcon";

import "bootstrap/dist/css/bootstrap.css";

import styles from "../../styles/menu.module.css";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiPaper-root": {
    minWidth: "200px !important;",
  },
  "& .MuiInputBase-input": {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 12,
    padding: "7px 26px 7px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Bosch-Medium", "Arial"].join(","),
    "&:focus": {
      borderRadius: 0,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: 12,
  },
  "& .MuiSvgIcon-root": {
    color: "333333",
    width: "17px",
  },
}));

function CustomSvgIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </SvgIcon>
  );
}

class Menu extends React.Component {
  constructor() {
    super();

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      productSelected: "compress7400",
      value: "coconut",
    };
  }

  static contextType = AppContext;

  componentDidMount() {}

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  trackingCall = (product) => {
    const productName = product.replace(/ /g, "_");

    window.parent.postMessage(
      {
        event: "HP-Soundtool",
        eventCategory: "ToolProductLink",
        eventAction: product,
      },
      "*"
    );

    console.log("Product link tracked: " + product);
  };

  changeProduct = (e) => {
    const {
      setProduct,
      productSelected,
      activeView,
      viewLocation,
      heatpumpVolume,
    } = this.context;

    var productToInt = parseInt(e.target.value);

    setProduct(productToInt);

    console.log(productSelected);

    this.props.action(viewLocation, heatpumpVolume, activeView, productToInt);

    //console.log(this.state.productSelected)
  };

  handleChange = (event) => {
    this.setState({ value: event.target.value });
  };

  render() {
    const { productSelected, products } = this.context;
    const { t } = this.props;

    const renderDropdown = () => {
      return (
        <Box sx={{ minWidth: 120, fontSize: "12px" }}>
          <FormControl fullWidth>
            <Select
              value={productSelected}
              label="Age"
              MenuProps={{
                style: {
                  fontFamily: "Bosch-Bold",
                  fontSize: 12,
                  zIndex: 99999999999,
                },
                disableScrollLock: true,
              }}
              onChange={this.changeProduct}
              input={<BootstrapInput />}
              IconComponent={CustomSvgIcon}
            >
              {products.map((product) => (
                <MenuItem
                  value={product.menuId}
                  key={product.menuId}
                  className={styles.smallFont}
                >
                  {product.name}
                </MenuItem>
              ))}
            </Select>

            {/* PRODUCT LINKS */}
            <div
              className={
                products[productSelected].productLink
                  ? styles.show
                  : styles.hide
              }
            >
              <a
                href={products[productSelected].productLink}
                target="_blank"
                rel="noreferrer"
                onClick={() => {
                  this.trackingCall(products[productSelected].productLink);
                }}
                className={styles.productLink}
              >
                {products[productSelected].productLinkText}
              </a>
            </div>
          </FormControl>
        </Box>
      );
    };

    return (
      <div
        style={{ width: "100%", textAlign: "left", margin: "20px 0 20px 0" }}
      >
        <h5
          style={{
            fontSize: "14px",
            fontFamily: "Bosch-Bold",
            paddingBottom: "10px",
          }}
        >
          {t("ui.distance.productChoice")}
        </h5>

        {renderDropdown()}
      </div>
    );
  }
}

export default withRouter(withTranslation()(Menu));
